import { atom } from 'jotai';
import { FeatureId, FeatureStatus, FEATURE_IDS } from './types';

const initialState = FEATURE_IDS.reduce(
  (acc, id) => {
    acc[id] = 'unknown';
    return acc;
  },
  {} as Record<FeatureId, FeatureStatus>,
);

/** Current per-feature availability map. Consumers read this via
 *  `useFeatureAvailability`. */
export const featureAvailabilityAtom = atom<Record<FeatureId, FeatureStatus>>(initialState);

/**
 * Write-only atom used by the probes to publish a status.
 *
 * Sticky-available: once a feature has been observed `available` in this
 * session we never downgrade it. The gateway round-robins old/new replicas
 * during the rolling deploy, so a feature that just answered 200 can 404 on
 * the very next probe — staying available avoids a flapping "enabling
 * soon" badge. A page-reload (new session) re-probes from scratch.
 */
export const setFeatureStatusAtom = atom(
  null,
  (get, set, update: { id: FeatureId; status: FeatureStatus }) => {
    const current = get(featureAvailabilityAtom);
    const prev = current[update.id];
    if (prev === 'available') return;
    if (prev === update.status) return;
    set(featureAvailabilityAtom, { ...current, [update.id]: update.status });
  },
);
